export default __webpack_public_path__ + "static/media/4.00ba3f66.png";